import { startButtonLoading } from './form_submit_guard';

/**
 * Enables the Continue button on the password-recovery channel-choice screen
 * once the user has picked a radio option (email or phone), and puts it into
 * a disabled loading state on submit so a slow request cannot double-fire.
 */
export const initChannelOptions = () => {
  const form = document.querySelector('.devise-form-recovery-channel form');
  if (!form) return;

  const radios = Array.from(form.querySelectorAll('input[name="channel"]'));
  const continueButton = document.getElementById('recovery-channel-continue');
  if (!radios.length || !continueButton) return;

  const syncContinue = () => {
    continueButton.disabled = radios.every((radio) => !radio.checked);
  };

  for (const radio of radios) radio.addEventListener('change', syncContinue);
  syncContinue();

  form.addEventListener('submit', () => startButtonLoading(continueButton));
};
